import type { AppRouteRecordRaw } from '/@/router/types';

import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from '/@/router/routes/basic';

import { mainOutRoutes } from './mainOut';
import { PageEnum } from '/@/enums/pageEnum';
import { t } from '/@/hooks/web/useI18n';

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE];

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('/@/views/sys/login/Login.vue'),
  meta: {
    title: t('routes.basic.login'),
  },
};

//  该文件主要处理 window.open 打开的小窗口的参数传递
const OpenerDispatch: AppRouteRecordRaw = {
  path: '/opener-dispatch',
  name: 'OpenerDispatch',
  component: () => import('/@/views/sys/openerDispatch/index.vue'),
  meta: {
    title: 'Opener Dispatch',
  },
};

// Basic routing without permission
export const basicRoutes = [
  LoginRoute,
  RootRoute,
  OpenerDispatch,
  ...mainOutRoutes,
  REDIRECT_ROUTE,
];
